/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  stage: 'Development',
  maxMessageLogs: 50, // Defines the qty of messages on the meny overlay

  // DEVELOPMENT ENVIRONMENT
  apiDocumentation: 'https://api.adelitadress.com.mx/index.html',
  apiEndpoint: 'https://api.adelitadress.com.mx/api/',
  //apiEndpoint: 'http://localhost:5000/api/',
  appName: 'Adelita - Administración de Rentas',
  appVersion: '1.0',
  basic_auth_token: '',
  customerPresentation: true,
  userRecord: 'record',
  imageNotFound: "https://upload.wikimedia.org/wikipedia/commons/d/da/Imagen_no_disponible.svg"
};
